// Código de liberação offline baseado em data
// Mesmo algoritmo deve estar no dashboard para gerar códigos
const SHARED_SECRET = "condorflix-offline-2024";

// Gera código de 6 dígitos válido por 1 dia
export function generateOfflineCode(
	activationPassword: string,
	date: Date = new Date(),
): string {
	const dateStr = date.toISOString().split("T")[0];
	const input = `${activationPassword}:${dateStr}:${SHARED_SECRET}`;

	let hash = 0;
	for (let i = 0; i < input.length; i++) {
		const char = input.charCodeAt(i);
		hash = (hash << 5) - hash + char;
		hash = hash & hash;
	}

	const code = Math.abs(hash % 1000000)
		.toString()
		.padStart(6, "0");
	return code;
}

// Valida código (verifica hoje e ontem para margem de fuso horário)
export function validateOfflineCode(
	activationPassword: string,
	inputCode: string,
): boolean {
	const today = new Date();
	const yesterday = new Date(today);
	yesterday.setDate(yesterday.getDate() - 1);

	const todayCode = generateOfflineCode(activationPassword, today);
	const yesterdayCode = generateOfflineCode(activationPassword, yesterday);

	return inputCode === todayCode || inputCode === yesterdayCode;
}
